import { Context } from "urql";
import isNil from "lodash/isNil";

import { RedirectionError } from "@lululemon/mwa-utils";
import Util from "@lululemon/ecom-common/src/lib/util";

import { getCNEGraphqlEndpoint } from "./helpers";
import { convertLocaleForGraphql } from "@lululemon/ecom-common/src/util/helpers";
import { constructGraphQlQuery } from "../utils/common";
import { logger } from "../utils/logger";

const util = new Util("lib/pdp-utils");

/**
 * @param params
 * @param productIdentifier a legacy parameter used to redifine graphql inputs
 * @returns {({isRequired: boolean, name: string, type: string, value}|{name: string, type: string, value}|{name: string, type: string, value}|{name: string, type: string, value}|{name: string, type: string, value: (boolean|null)})[]}
 */
export const constructPDPFields = (params, productIdentifier = "id") => {
  const {
    category,
    forceMemberCheck,
    forcePcm = false,
    locale,
    productId,
    sl,
    unifiedId,
  } = params || {};
  return [
    {
      type: "String",
      name: productIdentifier,
      label: "id",
      value: productId,
    },
    {
      type: "String!",
      name: "category",
      isRequired: true,
      label: "category",
      value: category,
    },
    {
      type: "String!",
      name: "unifiedId",
      isRequired: true,
      label: "unifiedId",
      value: unifiedId,
    },
    {
      type: "String",
      name: "locale",
      label: "locale",
      value: convertLocaleForGraphql(locale),
    },
    {
      type: "Boolean",
      name: "forceMemberCheck",
      label: "forceMemberCheck",
      value: !isNil(forceMemberCheck) ? forceMemberCheck === "true" : null,
    },
    {
      type: "String",
      name: "sl",
      label: "sl",
      value: sl,
    },
    {
      type: "Boolean",
      name: "forcePcm",
      label: "forcePcm",
      value: !!forcePcm,
    },
  ];
};

/**
 * @param response
 * @param time
 * @returns {Promise<{data: any, raw: {headers}, time}>}
 */
const handlePDPGraphqlResponse = (response, time) => {
  const { data } = response;
  if (data && data.productDetailPage) {
    return {
      data: data.productDetailPage,
      raw: { headers: response.headers },
      time,
    };
  }
  throw new RedirectionError({
    message: `Failed to fetch productDetailPage ${response}`,
    url: `/error/${response.status}?component=product-detail-page`,
  });
};

/**
 * Currently Unused?
 * @param params
 * @param queries
 * @param graphqlClient
 */
const fetchPDP = async (params = {}, queries, graphqlClient) => {
  try {
    Context.url = getCNEGraphqlEndpoint();
    const { query, options } = constructGraphQlQuery({
      operation: "productDetailPage",
      fields: constructPDPFields(params, "id"),
      returns: `{${queries?.join("") || ""}}`,
    });
    util.performance.start();

    if (options?.id) {
      options.productId = options.id;
    }

    const pdpQuery = `query productDetailPageQuery($productId: String!, $category: String!, $unifiedId: String!, $locale: String, $forceMemberCheck: Boolean, $sl: String, $forcePcm: Boolean){
      ${query}
    }`;
    const response = await graphqlClient
      .query(pdpQuery, options, Context)
      .toPromise();
    const time = util.performance.stop().loadTime;

    return handlePDPGraphqlResponse(response, time);
  } catch (error) {
    logger.error(`Error fetching PDP response`, {
      cause: error,
      functionName: "graphql.fetchPDP",
    });
    throw error;
  }
};

export default fetchPDP;
